import React from 'react';

class Header extends React.Component {
  render() {
    return (
      <div>
        <div id="topbanner"></div>
        <nav className="navbar navbar-expand-md bg-light navbar-light">
          <a className="navbar-brand" href="/soc/europe/">
            <img src="logo.svg" height="40" className="d-inline-block align-top" alt="" />
            <span className="d-none d-lg-inline">&nbsp;&nbsp;&nbsp;Schedule of Classes</span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse"
            aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav ml-auto">
            <a href="https://umuc.secure.force.com/apply/" target="_blank" className="btn btn-secondary m-1 float-right"><strong>APPLY NOW</strong></a>
              <a href="https://europe.umgc.edu/admissions/request-info.cfm" target="_blank" className="btn btn-secondary m-1 float-right"><strong>REQUEST INFO</strong></a>
              <a href="https://europe.umgc.edu/students/learning-resources/course-materials" target="_blank" className="btn btn-secondary m-1 float-right"><strong>COURSE MATERIALS</strong></a>
              <a href="https://europe.umgc.edu/" className="btn btn-primary m-1 float-right" target="_blank"> <strong>UMGC EUROPE WEBSITE</strong></a>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

export default Header;